import posthog from 'posthog-js';

/**
 * Tells PostHog who the signed-in user is, and which organisation they are in. It used to live
 * inside ManageIntercom.identifyUser; it has its own home so the support chat can change (Intercom
 * or the website's chat) without touching analytics. Reads the session from localStorage, as the
 * rest of the app does. Logout resets PostHog in AuthService.
 */
export class AnalyticsIdentity {
  static identify(): void {
    const userId = localStorage.getItem('Id');
    if (!userId) return;
    try {
      posthog.identify(userId, {
        email: localStorage.getItem('Email'),
        name: localStorage.getItem('UserName'),
      });
      const orgId = localStorage.getItem('SelectedOrganization');
      if (orgId) {
        posthog.group('company', orgId, {
          name: localStorage.getItem('SelectedOrganizationName') || orgId,
        });
      }
    } catch (err) {
      console.error('PostHog identify error:', err);
    }
  }
}
